module.exports = __webpack_public_path__ + "About-img.png?ba256a3b8350885ac12c703fcb4b3f79";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/About/About-img.png
// module id = 142
// module chunks = 0